import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  Avatar,
  Typography,
  Grid,
  Divider,
  Button,
} from '@material-ui/core';
import swal from 'sweetalert'

const useStyles = makeStyles(theme => ({
  root: {},
  details: {
    display: 'flex'
  },
  avatar: {
    marginLeft: 'auto',
    height: 110,
    width: 100,
    flexShrink: 0,
    flexGrow: 0
  },
  progress: {
    marginTop: theme.spacing(2)
  },
  uploadButton: {
    marginRight: theme.spacing(2),
    color:"#fff"
  }
}));

const UserAccount = props => {
  const { className, loading, users, activateUser, ...rest } = props;
  const classes = useStyles();
  console.log(users)
  const handleActivate = () => {
    swal({
      title: "Are you sure?",
      text: "Click Ok to continue",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        activateUser();
        swal("Loading...",{   
          buttons:false
        });
      }
    });
  }

  return (
    <div>
    <Card className={clsx(classes.root, className)} >
    <Grid>
      <CardContent>
        <div className={classes.details}>
          <div>
            <Typography
              gutterBottom
              variant="h3"
            >
              {users ? users.first_name + " " + " " + users.last_name : ""}
            </Typography>
            <Typography
              gutterBottom
              variant="h6"
            >
              {users ? users.member_id:""}
            </Typography>
            <Typography
              className={classes.locationText}
              color="textSecondary"
              variant="body1"
            >
              {users.address}
            </Typography>
          </div>
          <Avatar
            className={classes.avatar}
            src={users.profile_pic}
          />
        </div>
        {users.member_status === 0 && 
        <Button
          style={{color:'white',background:'green'}}
          variant="contained"
          onClick={()=>handleActivate()}>
            Activate
        </Button>}
      </CardContent>
    </Grid>
    <Divider />     
    </Card>
    </div>
  );
};

UserAccount.propTypes = {
  className: PropTypes.string
};

export default UserAccount;
